import React from 'react';
import { Popover as AntPopover } from 'antd';
import type { PopoverProps } from 'antd';
import clsx from 'clsx';

// NOTE: antd lands overlayClassName on the floating panel; className would land on
// the trigger, so the wrapper class is merged into overlayClassName.
export const Popover = ({ overlayClassName, ...props }: PopoverProps) => (
  <AntPopover
    {...props}
    overlayClassName={clsx('wk-popover', overlayClassName)}
  />
);
